module.exports = __webpack_public_path__ + "static/media/2026_WA-Footy-Lives-Here-Tile-Logged-Out-@1x.9617824d.webp";